export const get = async (url) => {
  const xAuthToken = localStorage.getItem('X-Auth-Token');
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Auth-Token': xAuthToken,
      },
    });
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error('An error occurred while making the GET request.');
  }
};
export const post = async (url, data) => {
  try {
    const xAuthToken = localStorage.getItem('X-Auth-Token');

    const headers = {
      'Content-Type': 'application/json',
    };

    if (xAuthToken) {
      headers['X-Auth-Token'] = xAuthToken;
    }

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error('An error occurred while making the POST request.');
  }
};

export const put = async (url, data) => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error('An error occurred while making the PUT request.');
  }
};
